import { useEffect, useState } from 'react';
import employeeQualificationService from '../../../services/EmployeeQualificationService';
import { getFormattedQualificationRecords } from '../helper/helper';

export default function useFetchEmployeesQualification(searchQuery) {
  const [employeesQualifications, setEmployeesQualifications] = useState([]);
  const [notSubmittedQualifications, setNotSubmittedQualifications] = useState([]);
  const [employeesQualificationsLoading, setEmployeesQualificationsLoading] = useState(false);
  const [employeesQualificationsError, setEmployeesQualificationsError] = useState(false);

  useEffect(() => {
    const fetchAllEmployeeQualifications = async () => {
      try {
        setEmployeesQualificationsLoading(true);
        const response = await employeeQualificationService.fetchEmployeesQualifications();
        const records = response.data?.data;

        const formattedRecords = getFormattedQualificationRecords(records);
        setNotSubmittedQualifications(
          formattedRecords.filter((qualification) => qualification.status?.toLowerCase() === 'not submitted')
        );

        const filteredQuals = formattedRecords.filter((quals) => {
          if (quals.status !== 'Not submitted') return true;

          return (quals.employeeMandatoryQualifications || []).includes(quals.name);
        });

        setEmployeesQualifications(filteredQuals);
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || 'error while fetching employees qualifications from verd db';

        setEmployeesQualificationsError(errorMessage);
      } finally {
        setEmployeesQualificationsLoading(false);
      }
    };
    fetchAllEmployeeQualifications();
  }, []);

  const filteredRows = searchRows(employeesQualifications, searchQuery);

  return {
    employeesQualifications: filteredRows,
    setEmployeesQualifications,
    notSubmittedQualifications,
    setNotSubmittedQualifications,
    employeesQualificationsLoading,
    employeesQualificationsError
  };
}

// search function. Search by: name. email, displayname, date, status, referenceNumber,employeeStatus and employeeId
function searchRows(allRows, query) {
  if (!query) return allRows;

  const lowerQuery = query.toLowerCase();
  const searchedRows = allRows.filter((r) => {
    return (
      (r.name && r.name.toLowerCase().includes(lowerQuery)) ||
      (r.employeeEmail && r.employeeEmail.toLowerCase().includes(lowerQuery)) ||
      (r.employeeDisplayName && r.employeeDisplayName.toLowerCase().includes(lowerQuery)) ||
      (r.referenceNumber && r.referenceNumber.toLowerCase().includes(lowerQuery)) ||
      (r.status && r.status.toLowerCase().includes(lowerQuery)) ||
      (r.employeeId && r.employeeId.toLowerCase().includes(lowerQuery)) ||
      (r.employeeKeyPayId && r.employeeKeyPayId.toLowerCase().includes(lowerQuery))
    );
  });

  return searchedRows;
}
